<template>
    <li class="promotion-active-item">
        <div class="item-top" @click="toDetail(itemP)">
            <template v-for="(pic,index) in itemP.picMap.picPromotionList" v-if="index<=0">
                <img :src="pic">
            </template>
        </div>
        <div class="item-bottom">
            <h3 @click="toDetail(itemP)">
                剩余<span>{{itemP.balanceCount}}{{itemP.productUnit}}</span> |
                距离活动结束<b v-if="itemP.day>0"><i>{{itemP.day}}</i>天</b><span>{{itemP.hour}}</span>时<span>{{itemP.minute}}</span>分<b v-if="itemP.day<=0"><i>{{itemP.second}}</i>秒</b></h3>
            <template v-if="itemP.seconds>0&&itemP.balanceCount>0&&itemP.isShow==1">
                <div class="right-buy">
                    <proOpera :itemPro="itemP" :speedUp="itemP.speedUp" :stockCount="itemP.speedupStockNum" :proId="itemP.promotionId" :promoId="itemP.promotionId" :protype="1" :proLimit="itemP.limitBuyCount" :proName="itemP.productName"></proOpera>
                </div>
            </template>
            <template v-else>
                <div class="btn-wrap">
                    <button class="buy-btn" @click="hasInventoryTips(itemP)">{{itemP.seconds<=0?'已结束':(itemP.balanceCount<=0?'到货提醒':'暂未解锁')}}<i class="icon iconfont icon-jiantouyou"></i></button>
                </div>
            </template>
        </div>
    </li>
</template>

<script>
    import proOpera from '@/components/index/product_opera.vue'

    export default{
        props:['itemP','vipLevel','vipDay'],
        components:{
            proOpera
        },
        mounted(){
            this.$set(this.itemP,'day',0);
            this.countDown(this.itemP)
        },
        methods:{
            setId(item){
                return item!=undefined?item+'-':''
            },
            countDown(item){
                let seconds = item.seconds;

                let int = window.setInterval(()=> {
                    let day = Math.floor(seconds / (24*3600))
                    let hour = Math.floor((seconds - day*24*3600)/ 3600);
                    let minute = Math.floor((seconds - day*24*3600-hour * 3600) / 60);
                    let second = Math.floor(seconds - day*24*3600-hour * 3600 - minute * 60);
                    if (seconds <= 0) {
                        clearInterval(int);
                        day = 0;
                        hour = 0;
                        minute = 0;
                        second = 0;

                    } else {
                        seconds--;

                    }
                    this.$set(item,'seconds',seconds);
                    this.$set(item,'day',day);
                    this.$set(item,'hour',zeroTime(hour));
                    this.$set(item,'minute',zeroTime(minute));
                    this.$set(item,'second',zeroTime(second));

                }, 1000);
                function zeroTime(item) {//时间显示处理
                    return parseInt(item) < 10 ? '0' + item : item;
                }
            },
            hasInventoryTips(item){
                if(item.balanceCount<=0){
                    invokeApi('reserve/reserve',{aliasId:item.promotionId,type:1},'get',Math.random(), (res)=> {
                        console.log(res);
                        this.$prompt(res)
                    })
                }else if(item.isShow!=1){
                    this.$prompt(`您的当前会员等级：V${this.vipLevel}<br/>买买买升到相应等级，可以购买噢！`)
                }

            },
            toDetail(item){
                if(item.detailWebFlag=='detail'){
                    window.location.href = `/pages/product_detail/promotion_detail/promotion_detail.html?proid=${item.promotionId}`
                }
            }
        }

    }
</script>

<style lang="scss" rel="stylesheet/scss">
    @import "../../resource/css/color";
    @import "css/promotion.scss";

</style>


// WEBPACK FOOTER //
// src/components/module_pro/promotion.vue